<template>
  <ClassroomTable @updateClass="updateClass" v-if="!showCalendar">
    <template #header>
      <h4>{{ $t("labels.generic", { pt: "Turmas", en: "Classes" }) }}</h4>
    </template>
  </ClassroomTable>
  <section v-if="showCalendar">
    <Agenda v-model:formVisible="formVisible">
      <template #header>
        <span class="flex flex-col mt-4">
          <Button
            class="btn-simple flex gap-4 !px-0"
            @click.prevent="backTableClass"
          >
            <v-icon name="co-arrow-left" width="24" height="24" />
            <h4>
              {{
                $t("labels.generic", {
                  pt: `Calendário de aulas: ${classSelected.name}`,
                  en: `Classes calendar: ${classSelected.name}`,
                })
              }}
            </h4>
          </Button>
          <Button
            :label="
              $t('labels.generic', { pt: 'Adicionar aula', en: 'Add class' })
            "
            icon="pi pi-plus"
           class="btn-primary p-button-sm"
            @click="showForm"
          />
        </span>
      </template>
    </Agenda>
  </section>
</template>

<script lang="ts">
import { Classroom } from "@/models/classrooms.model";
import { computed, defineAsyncComponent, defineComponent } from "vue";
const ClassroomTable = defineAsyncComponent(() => import("./table.vue"));
export default defineComponent({
  name: "classesContent",
  components: { ClassroomTable },
  data() {
    return {
      classSelected: new Classroom(),
      showCalendar: false,
      formVisible: false,
    };
  },
  methods: {
    updateClass(classroom: Classroom): void {
      Object.assign(this.classSelected, classroom);
      this.showCalendar = true;
    },
    backTableClass(): void {
      this.showCalendar = false;
    },
    showForm(): void {
      this.formVisible = true;
    },
  },
  provide() {
    return {
      selectedClassId: computed(() => {
        return this.classSelected?.id!;
      }),
      selectedCourseId: computed(() => {
        return this.$route.params.id;
      }),
    };
  },
});
</script>
